import React from 'react';
const SvgSpinner = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 100 100", focusable: false }, props),
    React.createElement("path", { d: "M50 100C22.4 99.967.033 77.6 0 50h10c0 22.091 17.909 40 40 40s40-17.909 40-40-17.909-40-40-40V0c27.614 0 50 22.386 50 50s-22.386 50-50 50z" })));
export default SvgSpinner;
//# sourceMappingURL=Spinner.js.map